import { pageWrapper } from '@src/prototypePages/wrapper';

import 'antd/dist/antd.css';

export const wrapPages = pageWrapper;

export const wrapPagesDeep = pageWrapper;

export default wrapPages;
